import { useEffect, useState } from 'react';
import { fetchCourses } from '@/services/learn/course.service';
import type { Course, LearnPage } from '@edwin-group/cj-graphql/generated/graphql';
import CoursesSkeleton from './Courses.skeleton';
import Container from '@/components/Container';
import Navigation, { NavigationSkeleton } from '@/components/ui/navigation';
import { navigationLearn } from '../constants';

import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import WelcomePageMessage from '@/components/WelcomePage';
import { getPage } from '@/services/learn/learn.service';
import CourseCard from '@/components/Card/Course';

function CoursesTab() {
  const [courses, setCourses] = useState<Array<Course> | null>(null);
  const [learnPage, setLearnPage] = useState<LearnPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const coursesResult = await fetchCourses();
      const pageResponse = await getPage();

      setCourses(coursesResult);
      setLearnPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  if (loading) {
    return (
      <>
        <NavigationSkeleton />
        <Container className="min-h-40 w-full">
          <CoursesSkeleton />
        </Container>
      </>
    );
  }

  return (
    <>
      <Navigation title="Learn" items={navigationLearn} />
      <WelcomePageMessage
        component={learnPage?.welcomePageMessage}
        hideDivider
        className="col-start-1 col-end-12 lg:col-start-3 lg:col-end-11"
      />
      <Container className="last-divider-hidden mt-sh-60 min-h-40">
        <div className="col-span-12 last:mb-0 lg:col-start-3 lg:col-end-11">
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            {courses?.map((course) => {
              return (
                <AnimatedFadeInComponent key={course!.title!}>
                  <CourseCard course={course} />
                </AnimatedFadeInComponent>
              );
            })}
          </div>
        </div>
      </Container>
    </>
  );
}

export default CoursesTab;
